let hideBtnActions = function(i, idx) {
	if (this.Actionsdropd[idx]) {
		this.Actionsdropd[idx] = false;
		this.ActionsSelected = 0;
		console.log('hideBtnActions', idx);
		this.desactivateActions();
	}
};
export default hideBtnActions;
